import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { get_bandwidth_stat, get_city_stat as _get_city_stat, get_city_status as _get_city_status, get_cpu_rank as _get_cpu_rank, get_link_rank as _get_link_rank } from "../../services/CI/CI0801S";
import { get_device_stat, get_link_stat as _get_link_stat, get_redis_alarm_stat as _get_redis_alarm_stat, get_bandwidth_stat_all as _get_bandwidth_stat_all, get_app_account_stat as _get_app_account_stat, get_healthy_status as _get_healthy_status, get_device_list as _get_device_list, get_company_list as _get_company_list, update_company as _update_company, get_alert_history_count as _get_alert_history_count, query_alert_history_aggregate as _query_alert_history_aggregate } from "../../services/Company/companyS";
import { get_internet_property, get_multi_band, get_rtt_data as _get_rtt_data, get_tunnel_ctrank as _get_tunnel_ctrank } from "../../services/rate/rateS";
import mapMessages from "../../locales/mapMessages";
import { healthMap, statusListMap } from "../../utils/commonUtilFunc";
import { BossMessage } from "../../components/Common/BossMessages";
import moment from 'moment';
import { get_main_flow as _get_main_flow } from '../../services/rate/rateS';
export default {
  namespace: "ci0801Info",
  state: {
    bandwidthStat: {},
    bandwidthTotal: 0,
    linkStat: {
      data: [],
      legend: []
    },
    deviceStat: {
      data: [],
      legend: []
    },
    agencyStat: [],
    nodeData: [],
    linkDataInit: [],
    linkDataOnline: [],
    linkDataOffline: [],
    linkSum: 0,
    deviceSum: 0,
    agencySum: 0,
    alarmStat: {
      device: {},
      link: {}
    },
    ifDomestic: true,
    linkTopBarData: [],
    deviceLinkTopData: [],
    appAccount: {
      app_count: 0,
      app_limit: 0
    },
    linkDataOnly: {},
    tunnelctrankData: [],
    linkDataState: [],
    deviceDataState: [],
    allalarmscount: 0,
    alarmList: [],
    cityStatusList: [],
    cpuRankList: [],
    linkRankList: [],
    deviceList: [],
    companyInfo: {},
    hcpeSpeedSeries: [],
    hasHcpeSpeed: false,
    deviceInfo: []
  },
  effects: {
    get_stat: function get_stat(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData1, backData2, pieData2, pieData3, pieData4, linkSum, deviceSum, agencySum, key;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(get_bandwidth_stat, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData1 = _context.sent;
              _context.next = 5;
              return call(get_device_stat, payload);
            case 5:
              backData2 = _context.sent; // const backData3 = yield call(get_link_stat, {...payload,is_active:1});
              // const backData4 = yield call(get_agency_stat, payload);
              pieData2 = {
                data: [],
                legend: []
              };
              pieData3 = {
                data: [],
                legend: []
              };
              pieData4 = {
                data: [],
                legend: []
              };
              linkSum = 0;
              deviceSum = 0;
              agencySum = 0;
              pieData2.data.push({
                value: backData2['ONLINE'] || 0,
                name: "on-line",
                search: "ONLINE",
                color: statusListMap('ONLINE').color,
                itemStyle: {
                  color: '#4C82E0'
                }
              });
              pieData2.data.push({
                value: backData2['OFFLINE'] || 0,
                name: "off-line",
                search: "OFFLINE",
                color: statusListMap('OFFLINE').color,
                itemStyle: {
                  color: '#FF3F41'
                }
              });
              pieData2.data.push({
                value: backData2['INIT'] || 0,
                name: "not active",
                search: "INIT",
                color: statusListMap('INIT').color,
                itemStyle: {
                  color: '#FAAD14'
                }
              });
              for (key in backData2) {
                deviceSum += backData2[key]; // switch (key) {
                //     case "OFFLINE":
                //         pieData2.data.push({value: backData2[key], name: "@离线",search:"OFFLINE",color:statusListMap('OFFLINE').color});
                //         deviceSum += backData2[key]
                //         break;
                //     case "ONLINE":
                //         pieData2.data.push({value: backData2[key], name: "@在线",search:"ONLINE",color:statusListMap('ONLINE').color});
                //         deviceSum += backData2[key]
                //         break;
                //     case "INIT":
                //         pieData2.data.push({value: backData2[key], name: "@未激活",search:"INIT",color:statusListMap('INIT').color});
                //         deviceSum += backData2[key]
                //         break;
                //     default:
                //         break;
                // }
                pieData2.legend.push(key);
              }
              if (!pieData2.data.length) {
                pieData2.data.push({
                  name: "There is currently no data available",
                  value: 0,
                  search: "暂无数据",
                  color: statusListMap('INIT').color,
                  itemStyle: {
                    color: '#FAAD14'
                  }
                });
              } // for (let key in backData3) {
              //     switch (key) {
              //         case "OFFLINE":
              //             pieData3.data.push({value: backData3[key], name: "@离线",search:"离线",color:statusListMap('OFFLINE').color});
              //             linkSum += backData3[key]
              //             pieData3.legend.push("@离线");
              //             break;
              //         case "ONLINE":
              //             pieData3.data.push({value: backData3[key], name: "@在线",search:"在线",color:statusListMap('ONLINE').color});
              //             linkSum += backData3[key];
              //             pieData3.legend.push("@在线");
              //             break;
              //         case "INIT":
              //             pieData3.data.push({value: backData3[key], name: "@未激活",search:"未激活",color:statusListMap('INIT').color});
              //             linkSum += backData3[key];
              //             pieData3.legend.push("@未激活");
              //             break;
              //         default:
              //             break;
              //     }
              // }
              if (!pieData3.data.length) {
                pieData3.data.push({
                  name: "There is currently no data available",
                  value: 0,
                  search: "暂无数据",
                  color: statusListMap('INIT').color
                });
              } // for (let key in backData4) {
              //     switch (key) {
              //         case "STEP":
              //             pieData4.data.push({value: backData4[key], name: "@边缘节点",search:"边缘节点",color:''});
              //             pieData4.legend.push("@边缘节点");
              //             agencySum = backData4[key];
              //             break;
              //         case "CSTEP":
              //             pieData4.data.push({value: backData4[key], name: "@中心节点",search:"中心节点",color:''});
              //             pieData4.legend.push("@中心节点");
              //             break;
              //         default:
              //             break;
              //     }
              // }
              _context.next = 20;
              return put({
                type: "update",
                payload: {
                  bandwidthStat: backData1,
                  bandwidthTotal: (backData1 && backData1["国内组网"] ? backData1["国内组网"] : 0) + (backData1 && backData1["全球组网"] ? backData1["全球组网"] : 0) + (backData1 && backData1["全球SaaS加速"] ? backData1["全球SaaS加速"] : 0) + (backData1 && backData1["国内SaaS加速"] ? backData1["国内SaaS加速"] : 0),
                  linkStat: pieData3,
                  deviceStat: pieData2,
                  agencyStat: pieData4,
                  linkSum: linkSum,
                  deviceSum: deviceSum,
                  agencySum: agencySum
                }
              });
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_city_stat: function get_city_stat(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var __, backData, nodeData, linkDataInit, linkDataOnline, linkDataOffline, _loop, key, _loop2, _key;
        return _regeneratorRuntime().wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              __ = payload.translate;
              delete payload.translate;
              _context4.next = 4;
              return call(_get_city_stat, payload);
            case 4:
              backData = _context4.sent;
              nodeData = [];
              linkDataInit = [];
              linkDataOnline = [];
              linkDataOffline = [];
              if (!backData.city_result) {
                _context4.next = 17;
                break;
              }
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var node, data;
                return _regeneratorRuntime().wrap(function _loop$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      node = {};
                      data = backData.city_result[key];
                      node.name = __(mapMessages[data.name], data.name);
                      node.value = [data.log, data.lat];
                      node.itemStyle = {
                        normal: {
                          color: {
                            type: 'radial',
                            x: 0.5,
                            y: 0.5,
                            r: 0.5,
                            colorStops: [{
                              offset: 0,
                              color: '#0471FF'
                            }, {
                              offset: 0.5,
                              color: '#fff'
                            }, {
                              offset: 0.8,
                              color: '#0471FF'
                            }]
                          }
                        }
                      };
                      node.tooltip = {
                        formatter: function formatter() {
                          var edge = "";
                          var center = "";
                          var links = "";
                          if (data.edge) {
                            if (data.center || data.links) {
                              edge = '<table class="map-tooltip-table"><tr><th class="title">' + "Edge nodes" + '</th><th class="count">' + "quantity" + '</th></tr><tr><td><li class="OFFLINE">' + "off-line" + '</li></td><td class="num">' + data.edge.OFFLINE + '</td></tr><td><li class="INIT">' + "not active" + '</li></td><td class="num">' + data.edge.INIT + '</td></tr><td><li class="ONLINE">' + "on-line" + '</li></td><td class="num">' + data.edge.ONLINE + '</td></tr><table/>';
                            } else {
                              edge = '<table class="map-tooltip-table" style="border-bottom: none"><tr><th class="title">' + "Edge nodes" + '</th><th class="count">' + "quantity" + '</th></tr><tr><td><li class="OFFLINE">' + "off-line" + '</li></td><td class="num">' + data.edge.OFFLINE + '</td></tr><td><li class="INIT">' + "not active" + '</li></td><td class="num">' + data.edge.INIT + '</td></tr><td><li class="ONLINE">' + "on-line" + '</li></td><td class="num">' + data.edge.ONLINE + '</td></tr><table/>';
                            }
                          }
                          if (data.center) {
                            if (data.links) {
                              center = '<table class="map-tooltip-table"><tr><th class="title">' + "Central node" + '</th><th class="count">' + "quantity" + '</th></tr><tr><td><li class="OFFLINE">' + "off-line" + '</li></td><td class="num">' + data.center.OFFLINE + '</td></tr><td><li class="INIT">' + "not active" + '</li></td><td class="num">' + data.center.INIT + '</td></tr><td><li class="ONLINE">' + "on-line" + '</li></td><td class="num">' + data.center.ONLINE + '</td></tr><table/>';
                            } else {
                              center = '<table class="map-tooltip-table" style="border-bottom: none"><tr><th class="title">' + "Central node" + '</th><th class="count">' + "quantity" + '</th></tr><tr><td><li class="OFFLINE">' + "off-line" + '</li></td><td class="num">' + data.center.OFFLINE + '</td></tr><td><li class="INIT">' + "not active" + '</li></td><td class="num">' + data.center.INIT + '</td></tr><td><li class="ONLINE">' + "on-line" + '</li></td><td class="num">' + data.center.ONLINE + '</td></tr><table/>';
                            }
                          }
                          if (data.links) {
                            links = '<table class="map-tooltip-table" style="border-bottom: none"><tr><th class="title">' + "Link information" + '</th><th class="count">' + "quantity" + '</th></tr><tr><td><li class="OFFLINE">' + "off-line" + '</li></td><td class="num">' + data.links.OFFLINE + '</td></tr><td><li class="INIT">' + "not active" + '</li></td><td class="num">' + data.links.INIT + '</td></tr><td><li class="ONLINE">' + "on-line" + '</li></td><td class="num">' + data.links.ONLINE + '</td></tr><table/>';
                          }
                          return '<div class="map-tooltip">' + edge + center + links + '</div>';
                        },
                        backgroundColor: "#fff",
                        extraCssText: 'box-shadow: 0 2px 2px 0 rgba(24,24,24,0.60);border-radius: 2px 2px 0 0 0 2px 2px;z-index:9999',
                        position: "right"
                      };
                      nodeData.push(node);
                    case 7:
                    case "end":
                      return _context2.stop();
                  }
                }, _loop);
              });
              _context4.t0 = _regeneratorRuntime().keys(backData.city_result);
            case 12:
              if ((_context4.t1 = _context4.t0()).done) {
                _context4.next = 17;
                break;
              }
              key = _context4.t1.value;
              return _context4.delegateYield(_loop(), "t2", 15);
            case 15:
              _context4.next = 12;
              break;
            case 17:
              if (!backData.link_result) {
                _context4.next = 25;
                break;
              }
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var link, data;
                return _regeneratorRuntime().wrap(function _loop2$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      link = {};
                      data = backData.link_result[_key];
                      link.coords = data.city_coord_pair;
                      link.tooltip = {
                        formatter: function formatter() {
                          var links = '<table class="map-tooltip-table" style="border-bottom: none"><tr><th class="title">' + "Link status" + '</th><th class="count">' + "quantity" + '</th></tr><tr><td><li class="OFFLINE">' + "off-line" + '</li></td><td class="num">' + data.OFFLINE + '</td></tr><td><li class="INIT">' + "not active" + '</li></td><td class="num">' + data.INIT + '</td></tr><td><li class="ONLINE">' + "on-line" + '</li></td><td class="num">' + data.ONLINE + '</td></tr><table/>';
                          return '<div class="map-tooltip">' + links + '</div>';
                        },
                        backgroundColor: "#fff",
                        extraCssText: 'box-shadow: 0 2px 2px 0 rgba(24,24,24,0.60);border-radius: 2px 2px 0 0 0 2px 2px;z-index:9999',
                        position: "right"
                      };
                      if (data.INIT !== 0) {
                        linkDataInit.push(link);
                      }
                      if (data.ONLINE !== 0) {
                        linkDataOnline.push(link);
                      }
                      if (data.OFFLINE !== 0) {
                        linkDataOffline.push(link);
                      }
                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop2);
              });
              _context4.t3 = _regeneratorRuntime().keys(backData.link_result);
            case 20:
              if ((_context4.t4 = _context4.t3()).done) {
                _context4.next = 25;
                break;
              }
              _key = _context4.t4.value;
              return _context4.delegateYield(_loop2(), "t5", 23);
            case 23:
              _context4.next = 20;
              break;
            case 25:
              _context4.next = 27;
              return put({
                type: "update",
                payload: {
                  nodeData: nodeData,
                  linkDataOffline: linkDataOffline,
                  linkDataOnline: linkDataOnline,
                  linkDataInit: linkDataInit,
                  ifDomestic: backData.is_domestic
                }
              });
            case 27:
            case "end":
              return _context4.stop();
          }
        }, _callee2);
      })();
    },
    get_redis_alarm_stat: function get_redis_alarm_stat(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_redis_alarm_stat, payload);
            case 2:
              backData = _context5.sent;
              _context5.next = 5;
              return put({
                type: "update",
                payload: {
                  alarmStat: backData
                }
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee3);
      })();
    },
    changeMapView: function changeMapView(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return put({
                type: "update",
                payload: {
                  ifDomestic: payload.ifDomestic
                }
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee4);
      })();
    },
    get_bandwidth_stat_all: function get_bandwidth_stat_all(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData, band_stat;
        return _regeneratorRuntime().wrap(function _callee5$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(_get_bandwidth_stat_all, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData = _context7.sent;
              band_stat = [];
              band_stat.push({
                name: '<10',
                value: backData['<10']
              });
              band_stat.push({
                name: '10-50',
                value: backData['10-50']
              });
              band_stat.push({
                name: '50-100',
                value: backData['50-100']
              });
              band_stat.push({
                name: '>=100',
                value: backData['>=100']
              });
              _context7.next = 10;
              return put({
                type: "update",
                payload: {
                  linkTopBarData: band_stat
                }
              });
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee5);
      })();
    },
    get_rtt_data: function get_rtt_data(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_get_rtt_data, payload);
            case 2:
              backData = _context8.sent;
              _context8.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceLinkTopData: backData.data.map(function (item) {
                    return _objectSpread({}, item, {
                      value: Number((item.flow / 1024 / 1024).toFixed(2))
                    });
                  }).reverse()
                }
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee6);
      })();
    },
    get_app_account_stat: function get_app_account_stat(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_get_app_account_stat, payload);
            case 2:
              backData = _context9.sent;
              _context9.next = 5;
              return put({
                type: "update",
                payload: {
                  appAccount: {
                    app_count: backData.app_count || 0,
                    app_limit: backData.app_limit || 0
                  }
                }
              });
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee7);
      })();
    },
    get_link_stat: function get_link_stat(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee8$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(_get_link_stat, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData = _context10.sent;
              _context10.next = 5;
              return put({
                type: "update",
                payload: {
                  linkDataOnly: backData
                }
              });
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee8);
      })();
    },
    get_tunnel_ctrank: function get_tunnel_ctrank(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee9$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return call(_get_tunnel_ctrank, payload);
            case 2:
              backData = _context11.sent;
              data = backData.data; // for(let i=0;i<backData.data.length;i++){
              //     const backData2 = yield call(get_link, {id:backData.data[i].tid});
              //     data[i].link_info = backData2.link_info
              // }
              _context11.next = 6;
              return put({
                type: "update",
                payload: {
                  tunnelctrankData: data
                }
              });
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee9);
      })();
    },
    get_healthy_status: function get_healthy_status(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData, linkData, deviceData, i, _i2;
        return _regeneratorRuntime().wrap(function _callee10$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_get_healthy_status, _objectSpread({}, payload, {
                is_active: 1
              }));
            case 2:
              backData = _context12.sent;
              linkData = [], deviceData = [];
              for (i in backData.link) {
                linkData.push({
                  name: healthMap(i).name,
                  stack: 'sum',
                  data: [backData.link[i] || 0],
                  type: 'bar',
                  search: i,
                  color: healthMap(i).color
                });
              }
              for (_i2 in backData.device) {
                deviceData.push({
                  name: healthMap(_i2).name,
                  stack: 'sum',
                  data: [backData.device[_i2] || 0],
                  type: 'bar',
                  search: _i2,
                  color: healthMap(_i2).color
                });
              }
              _context12.next = 8;
              return put({
                type: "update",
                payload: {
                  linkDataState: linkData,
                  deviceDataState: deviceData
                }
              });
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee10);
      })();
    },
    get_alert_history_count: function get_alert_history_count(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee11$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_get_alert_history_count, payload);
            case 2:
              backData = _context13.sent;
              _context13.next = 5;
              return put({
                type: "update",
                payload: {
                  allalarmscount: backData.data && backData.data.total ? backData.data.total : 0
                }
              });
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee11);
      })();
    },
    get_device_list: function get_device_list(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee12$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_get_device_list, payload);
            case 2:
              backData = _context14.sent;
              _context14.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee12);
      })();
    },
    get_device_info: function get_device_info(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee13$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_get_device_list, payload);
            case 2:
              backData = _context15.sent;
              _context15.next = 5;
              return put({
                type: "update",
                payload: {
                  deviceInfo: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee13);
      })();
    },
    query_alert_history_aggregate: function query_alert_history_aggregate(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_query_alert_history_aggregate, payload);
            case 2:
              backData = _context16.sent;
              _context16.next = 5;
              return put({
                type: "update",
                payload: {
                  alarmList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  total: backData.total
                }
              });
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee14);
      })();
    },
    get_city_status: function get_city_status(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData, nodeData, nodeDataInit, nodeDataOnline, nodeDataOffline, linkDataInit, linkDataOnline, linkDataOffline, key, node, data, _loop3, _key2;
        return _regeneratorRuntime().wrap(function _callee15$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              // const __ = payload.translate;
              delete payload.translate;
              _context18.next = 3;
              return call(_get_city_status, payload);
            case 3:
              backData = _context18.sent;
              nodeData = [];
              nodeDataInit = [];
              nodeDataOnline = [];
              nodeDataOffline = [];
              linkDataInit = [];
              linkDataOnline = [];
              linkDataOffline = [];
              if (backData.city_result) {
                for (key in backData.city_result) {
                  node = {};
                  data = backData.city_result[key];
                  node.name = data.name + '(' + data.device_num + ')'; // node.name = __(mapMessages[data.name], data.name);
                  node.value = [data.log, data.lat];
                  if (data.color <= 30) {
                    nodeDataInit.push(node);
                  } else if (data.color <= 50) {
                    nodeDataOnline.push(node);
                  } else {
                    nodeDataOffline.push(node);
                  }
                  nodeData.push(node);
                }
              }
              if (!backData.link_result) {
                _context18.next = 20;
                break;
              }
              _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
                var link, data;
                return _regeneratorRuntime().wrap(function _loop3$(_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      link = [];
                      data = backData.link_result[_key2]; // link.coords = data.city_coord_pair;
                      data.link_info.map(function (item, index) {
                        link.push({
                          coords: data.city_coord_pair,
                          name: item.link_name,
                          id: item.link_id,
                          cityName: data.city_name_pair,
                          lineStyle: {
                            width: 2,
                            curveness: 0.2 + index * 0.1
                          }
                        }); // link.coords = data.city_coord_pair;
                        // link.name = data.city_name_pair;
                        // link.id = item
                        // link.lineStyle ={
                        //     width: 2,
                        //     curveness: 0.2+index*0.1,
                        // }
                      }); // link.id = data.link_ids
                      // link.lineStyle ={
                      //     normal: {
                      //         color: "black",
                      //         width: 2,
                      //         curveness: 0.7,
                      //     },
                      // }
                      if (data.color <= 30) {
                        linkDataInit = linkDataInit.concat(link);
                      } else if (data.color <= 50) {
                        linkDataOnline = linkDataOnline.concat(link);
                      } else {
                        linkDataOffline = linkDataOffline.concat(link);
                      }
                    // if (data.ONLINE !== 0) {
                    //     linkDataOnline.push(link);
                    // }
                    // if (data.OFFLINE !== 0) {
                    //     linkDataOffline.push(link);
                    // }
                    case 4:
                    case "end":
                      return _context17.stop();
                  }
                }, _loop3);
              });
              _context18.t0 = _regeneratorRuntime().keys(backData.link_result);
            case 15:
              if ((_context18.t1 = _context18.t0()).done) {
                _context18.next = 20;
                break;
              }
              _key2 = _context18.t1.value;
              return _context18.delegateYield(_loop3(), "t2", 18);
            case 18:
              _context18.next = 15;
              break;
            case 20:
              _context18.next = 22;
              return put({
                type: "update",
                payload: {
                  nodeData: nodeData,
                  linkDataOffline: linkDataOffline,
                  linkDataOnline: linkDataOnline,
                  linkDataInit: linkDataInit,
                  ifDomestic: backData.is_domestic,
                  nodeDataInit: nodeDataInit,
                  nodeDataOnline: nodeDataOnline,
                  nodeDataOffline: nodeDataOffline
                }
              });
            case 22:
            case "end":
              return _context18.stop();
          }
        }, _callee15);
      })();
    },
    // * get_city_status({ payload }, { call, put }) {
    //     const backData = yield call(get_city_status, payload);
    //     yield put({
    //         type: "update",
    //         payload: {
    //             cityStatusList: backData.result && Array.isArray(backData.result)?backData.result:[]
    //         }
    //     })
    // },
    get_cpu_rank: function get_cpu_rank(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_get_cpu_rank, payload);
            case 2:
              backData = _context19.sent;
              _context19.next = 5;
              return put({
                type: "update",
                payload: {
                  cpuRankList: backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context19.stop();
          }
        }, _callee16);
      })();
    },
    get_link_rank: function get_link_rank(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee17$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_get_link_rank, payload);
            case 2:
              backData = _context20.sent;
              _context20.next = 5;
              return put({
                type: "update",
                payload: {
                  linkRankList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee17);
      })();
    },
    get_company_list: function get_company_list(_ref35, _ref36) {
      var payload = _ref35.payload,
        callback = _ref35.callback;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData, companyInfo;
        return _regeneratorRuntime().wrap(function _callee18$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context21.sent;
              companyInfo = backData.result && Array.isArray(backData.result) && backData.result[0] ? backData.result[0] : {};
              if (callback && typeof callback === 'function') {
                callback(companyInfo);
              }
              _context21.next = 7;
              return put({
                type: "update",
                payload: {
                  companyInfo: companyInfo
                }
              });
            case 7:
            case "end":
              return _context21.stop();
          }
        }, _callee18);
      })();
    },
    update_company: function update_company(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_update_company, payload.update);
            case 2:
              backData = _context22.sent;
              if (backData.success) {
                BossMessage(true, "Operation successful"); // const backData2=yield call(get_company_list,payload.init);
                // yield put({
                //     type:"update",
                //     payload:{
                //         companyInfo: backData2.result && Array.isArray(backData2.result)&&backData2.result[0]?backData2.result[0]:{}
                //     }
                // })
              } else {
                BossMessage(false, "操作失败" + backData.result);
              }
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee19);
      })();
    },
    get_main_flow: function get_main_flow(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData, hasHcpeSpeed, speedSeries, seriesTx, seriesRx, key, data, time;
        return _regeneratorRuntime().wrap(function _callee20$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!payload.sn) {
                _context23.next = 6;
                break;
              }
              _context23.next = 3;
              return call(_get_main_flow, payload);
            case 3:
              backData = _context23.sent;
              _context23.next = 7;
              break;
            case 6:
              backData = {
                retcode: 0,
                data: []
              };
            case 7:
              hasHcpeSpeed = false;
              speedSeries = [];
              seriesTx = {
                name: "Uplink rate",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#4C82E0"
                },
                itemStyle: {
                  color: "#4C82E0"
                }
              };
              seriesRx = {
                name: "Downlink rate",
                data: [],
                type: "line",
                showSymbol: false,
                smoothMonotone: "x",
                smooth: true,
                animation: false,
                lineStyle: {
                  color: "#696CAD"
                },
                itemStyle: {
                  color: "#696CAD"
                }
              };
              if (backData.msg === "ok" || backData.retcode === 0) {
                for (key in backData.data) {
                  data = backData.data[key];
                  time = moment.unix(backData.data[key].time).format("YYYY-MM-DD HH:mm:ss");
                  seriesRx.data.push([time, (data.raterx * 8 / 1024).toFixed(4)]);
                  seriesTx.data.push([time, (data.ratetx * 8 / 1024).toFixed(4)]);
                }
                if (backData.data.length > 0) {
                  hasHcpeSpeed = true;
                }
              }
              speedSeries.push(seriesRx);
              speedSeries.push(seriesTx);
              _context23.next = 16;
              return put({
                type: "update",
                payload: {
                  hcpeSpeedSeries: speedSeries,
                  hasHcpeSpeed: hasHcpeSpeed
                }
              });
            case 16:
            case "end":
              return _context23.stop();
          }
        }, _callee20);
      })();
    },
    getMapLineData: function getMapLineData(_ref41, _ref42) {
      var payload = _ref41.payload,
        callback = _ref41.callback;
      var call = _ref42.call,
        put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var multibandData, backData2, ratetx, raterx, rtt;
        return _regeneratorRuntime().wrap(function _callee21$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return call(get_multi_band, {
                company_id: payload.company_id,
                tid: payload.id,
                tunnel_id: payload.id,
                start_tm: payload.start_tm,
                end_tm: payload.end_tm
              });
            case 2:
              multibandData = _context24.sent;
              _context24.next = 5;
              return call(get_internet_property, {
                company_id: payload.company_id,
                tid: payload.id,
                tunnel_id: payload.id,
                start_tm: payload.start_tm,
                end_tm: payload.end_tm
              });
            case 5:
              backData2 = _context24.sent;
              ratetx = '', raterx = '', rtt = '';
              rtt = backData2 && backData2.data && backData2.data[0] && backData2.data[0].rtt ? backData2.data[0].rtt : "";
              if (backData2 && backData2.data && backData2.data.length > 0) {
                rtt = backData2.data[backData2.data.length - 1].rtt;
              }
              if (multibandData && multibandData.data && Array.isArray(multibandData.data)) {
                multibandData.data.map(function (item) {
                  if (item.nettp === 1000) {
                    if (item.bands && item.bands.length > 0) {
                      ratetx = item.bands[item.bands.length - 1].ratetx;
                      raterx = item.bands[item.bands.length - 1].raterx;
                    }
                  }
                });
              }
              if (callback && typeof callback === 'function') {
                callback({
                  ratetx: ratetx,
                  raterx: raterx,
                  rtt: rtt
                });
              }
            case 11:
            case "end":
              return _context24.stop();
          }
        }, _callee21);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};